export default function(minutos) {
  const horas = Math.floor(Math.abs(minutos / 60)),
      negativo = minutos < 0,
      resto = Math.abs(minutos % 60),
      partes = [
        horas ? horas + 'h' : '',
        resto ? resto + 'm' : ''
      ];

  return (negativo ? '-' : '') + partes.join('') || '—';
}